import React from "react";
import { Container, Text, Stack, Flex } from "@mantine/core";
import styles from "./Footer.module.css";
import { nonProtectedRoutes } from "../../utils/nonProtectedRoutingPaths";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <Container size="xl" className={styles.footerContent}>
        <Flex direction="row" justify="center" align="flex-start" gap="xl">
          <Text size="sm" c="dimmed">
            © {currentYear} Socius Legal Corporation
          </Text>
          <Stack spacing="xs" className={styles.policyLinks}>
            <Text component="a" href={nonProtectedRoutes.TERMS} size="sm">
              Terms of Service
            </Text>
          </Stack>
        </Flex>
      </Container>
    </footer>
  );
};

export default Footer;
